import MediaApiService from '@root/modules/podcast/services/mediaApi.service';
import { Podcast, MediaData } from '@root/modules/podcast/types/podcast';
import getAssetType from '@root/modules/podcast/utils/getAssetType';

const getCoreMediaData = async (episodes: Podcast[], customerToken?: string | null, getPlaylistLocation: boolean = true): Promise<MediaData[] | null> => {
  const mediaData: MediaData[] = [];
  const mediaAssets = [];

  for (const episode of episodes) {
    const assetType = getAssetType(episode);
    switch (assetType) {
      case 'podcasts':
      case 'audiobooks':
        mediaAssets.push(episode.content?.leadElement?.content[0]?.attrs?.id);
        mediaData.push({ id: episode.id, assetId: episode.content?.leadElement?.content[0]?.attrs?.id, assetType });
        break;
    }
  }

  if (mediaAssets.length) {
    const mediaApiService = new MediaApiService();
    const mediaItems = await mediaApiService.fetch({ id: mediaAssets, getPlaylistLocation });
    if (mediaItems?.length) {
      for (const mediaItem of mediaItems) {
        const assetId = mediaItem?.id;
        const assetUrl = mediaItem?.audioData?.audioPlaylistLocation || null;
        const assetDuration = mediaItem?.audioData?.audioDuration || null;
        const assetIndex = mediaData.map((m) => m.assetId).indexOf(assetId);

        if (mediaData[assetIndex]) {
          mediaData[assetIndex] = { ...mediaData[assetIndex], assetUrl, assetDuration };
        }
      }
    }
  }

  return mediaData;
};

export default getCoreMediaData;
